export function initConsoleWarning() {
    const backup = console.warn;
    console.warn = function filterWarnings(msg) {
        const supressedWarnings = [
            "setNativeProps is deprecated",
            "This renderer process has either no Content Security",
        ];
        try {
            if (!supressedWarnings.some((entry) => msg?.includes(entry))) {
                backup.apply(console, arguments as any);
                // global.electronAPI?.doLog(arguments as any);
            }

        } catch (error) {
            backup(msg, msg.trace);
        }
    };
}
export function initConsoleError() {
    const backup = console.error;
    console.error = function filterWarnings(msg) {
        const supressedWarnings = ["Warning: Using UNSAFE_componentWillMount in strict mode","Warning: Using UNSAFE_componentWillReceiveProps"];
        try {
            if (!supressedWarnings.some((entry) => msg?.includes(entry))) {
                backup.apply(console, arguments as any);
                // global.electronAPI?.doLog(arguments as any);
            }

        } catch (error) {
            backup(msg, msg.trace);
        }

    };
}
export function initConsoleLog() {
    const backup = console.log;
    if (process.env.NODE_ENV === "development") {
        return;
    }
    console.log = function filterWarnings(msg) {
        try {
            backup.apply(console, (Array.from(arguments)).concat(msg.trace));
            // global.electronAPI?.doLog(Array.from(arguments));

        } catch (error) {
            console.error(error);
            backup(msg);
        }

    };
}

initConsoleWarning();
initConsoleError();
initConsoleLog();
